// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --sidebar-width: 256px;/* Define the width of your sidebar */
    --sidebar-height:100% ;
  }
.calender-page-container{
    display:flex;
    flex-direction: column;
    width:20%;
    height:100%;
    background-color: white;  
    font-family: "PlusJakartaSans";
    border-radius: 1rem;
    /* margin-left: calc(85vw - var(--sidebar-width)); */
    right:0%;
    position:absolute;
    z-index:100;
    box-shadow: 1px 2px 9px rgb(219, 219, 219);
    /* margin-top:-3%; */
    top:0%;
}
.calender-page-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width:100%;
    font-weight: 600;
    margin-bottom:2rem;
    background-color: rgb(13, 13, 48);
    color:white;
    padding:1.5rem;
}
label{
    margin-bottom: 0.75rem;
    font-weight:500;
    color:rgb(69, 79, 91);
}
.calender-page-margin-container{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items:center;
    height:100%;
    padding: 1.5rem;;
}
.calender-page-content{
    display: flex;
    flex-direction:column;
    width:100%;
    align-items: center;
    justify-content: center;
    border-radius:1rem;
    border:1px solid rgb(223, 227, 232);
    padding-top:0.75rem;
    padding-bottom:4.5rem;
}
.calender-in-title-container{
    display: flex;
    flex-direction: column;
    width:100%;
    padding:0.5rem;
    border-bottom:1px solid rgb(231, 234, 237);
}
.calender-text-cotainer{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.calender-in-input{
    border: none;
    font-size: 22px;
    color:black;
}
.react-calendar {
    border: none; /* Remove the border from the calendar container */
    width:100%;
    font-family:system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }
  .react-calendar__navigation__label{
    /* font-weight:600; */
    font-size:1rem;
  }
 .react-calendar__month-view__weekdays__weekday{
    font-weight:400;
    text-decoration:none;
 }
.react-calendar__month-view__weekdays__weekday abbr{
    text-decoration:none;
}
  .react-calendar__tile {
    border: none; /* Remove the border from individual tiles */
  }
  .react-calendar__month-view__days__day--weekend{
    color:black;
  }
  .react-calendar__tile:hover{
    background-color:white;
    border:1px solid transparent;
  }
  .react-calendar__tile--active:enabled{
    background-color:rgb(64, 64, 242);
    border:1px solid rgb(64, 64, 242);
    color:white;
  }
  .react-calendar__month-view .react-calendar__tile--active:enabled:hover, .react-calendar__tile--active:enabled:focus {
    background-color:rgb(64, 64, 242);
    border-radius: 50%;
  }
  
.react-calendar button {
    background-color:white;
    border:1px solid transparent;
    color:black;
  }
.react-calendar__month-view .react-calendar button:hover {
    cursor: pointer;
    background-color:white;
    border:1px solid rgb(64, 64, 242);
    border-radius: 50%;

  }
  .react-calendar__tile:hover{
    background-color:white;
    border:1px solid rgb(64, 64, 242);
  }
.calender-page-footer{
    display: flex;
    align-items:center;
    justify-content: flex-end;
    width:100%;
    padding:0.5rem;
    padding-left:1.5rem;
    padding-right:1.5rem; 
    font-family: "PlusJakartaSans";
    box-shadow: 1px 2px 9px rgb(219, 219, 219);
}
.footer-btn-container{
   display:flex;
   width: -moz-fit-content;
   width: fit-content;
   height: -moz-fit-content;
   height: fit-content;
   background-color: white;
   border-radius:0.25rem;
   gap:1rem; 
}
.calender-page-cancel-btn,.calender-page-save-btn{
    display: flex;
    align-items:center;
    justify-content: center;
    text-align:center;
    padding:0.5rem;
    height:2.5rem; 
    border-radius:0.25rem; 
}
.calender-page-cancel-btn{
    border:2px solid rgb(64, 64, 242);;
    color:rgb(64, 64, 242);
    background-color: white; 
}
.calender-page-save-btn{
    background-color: rgb(64, 64, 242);
    border:2px solid rgb(64, 64, 242);
    color:white;
}
.calender-div{
 display:flex;
 position:absolute;
 margin-top:30%;
 align-items:center;
 justify-content: center;
 width:100%;
}
.rdrCalendarWrapper{
    width:95%;
}
.rdrDateDisplayItemActive{
    border: 1px solid rgb(64, 64, 242) !important;
}
.rdrMonths,.rdrMonth{
    width:100%;
    align-items: center;
    justify-content: center;
}
.rdrInRange{
 background-color:rgb(217, 217, 252) !important;
}
.rdrStartEdge,.rdrEndEdge{
    background-color:rgb(64, 64, 242) !important;
    color:white !important;
    /* width:80%; */
    /*height:100%; */
    /* border-radius: 50% !important; */
    /* align-items: center !important;
    justify-content: center !important; */
}
.rdrDayStartPreview,.rdrDayEndPreview{
    background-color:rgb(64, 64, 242) !important;
    color:white !important;
}
.rdrDayHovered > span,.rdrDayHovered > span > span,.rdrDay > span,.rdrDayInPreview{
    color:white !important;
}
.rdrDayNumber{
    z-index:10;
    color:white;
}
@media only screen and (max-width: 1281px) and (min-width: 720px) {
    .calender-page-container{
      /* margin-top:-5%; */
    }
    .calender-in-input{
      font-size: 16px;
    }
    
}
@media only screen and (max-height: 700px) and (min-height: 300px) {
  .calender-page-container{
    /* margin-top:-4%; */
  }
  .react-calendar{
    /* height:100px; */
  }
  .calender-in-input{
    font-size: 14px;
  }
  .calender-page-header{
    margin-bottom:0;
  }
  .calender-page-content{
    padding-bottom:1rem;
  }
  .react-calendar__navigation {
    margin-bottom:0;
  }
  .calender-page-margin-container{
    padding:0.75rem;
  }
  .calender-container{
    padding:0.5rem;
  }
  
  }`, "",{"version":3,"sources":["webpack://./src/pages/report/components/Calender/Calender.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB,CAAC,qCAAqC;IAC5D,sBAAsB;EACxB;AACF;IACI,YAAY;IACZ,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,8BAA8B;IAC9B,mBAAmB;IACnB,oDAAoD;IACpD,QAAQ;IACR,iBAAiB;IACjB,WAAW;IACX,0CAA0C;IAC1C,oBAAoB;IACpB,MAAM;AACV;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,WAAW;IACX,cAAc;AAClB;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mCAAmC;IACnC,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,cAAc;IACd,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;AACf;AACA;IACI,YAAY,EAAE,kDAAkD;IAChE,UAAU;IACV,kJAAkJ;EACpJ;EACA;IACE,qBAAqB;IACrB,cAAc;EAChB;CACD;IACG,eAAe;IACf,oBAAoB;CACvB;AACD;IACI,oBAAoB;AACxB;EACE;IACE,YAAY,EAAE,4CAA4C;EAC5D;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,4BAA4B;EAC9B;EACA;IACE,iCAAiC;IACjC,iCAAiC;IACjC,WAAW;EACb;EACA;IACE,iCAAiC;IACjC,kBAAkB;EACpB;;AAEF;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,WAAW;EACb;AACF;IACI,eAAe;IACf,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;;EAEpB;EACA;IACE,sBAAsB;IACtB,iCAAiC;EACnC;AACF;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,8BAA8B;IAC9B,0CAA0C;AAC9C;AACA;GACG,YAAY;GACZ,uBAAkB;GAAlB,kBAAkB;GAClB,wBAAmB;GAAnB,mBAAmB;GACnB,uBAAuB;GACvB,qBAAqB;GACrB,QAAQ;AACX;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,qBAAqB;AACzB;AACA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,kCAAkC;IAClC,iCAAiC;IACjC,WAAW;AACf;AACA;CACC,YAAY;CACZ,iBAAiB;CACjB,cAAc;CACd,kBAAkB;CAClB,uBAAuB;CACvB,UAAU;AACX;AACA;IACI,SAAS;AACb;AACA;IACI,6CAA6C;AACjD;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;CACC,8CAA8C;AAC/C;AACA;IACI,4CAA4C;IAC5C,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC;yCACqC;AACzC;AACA;IACI,4CAA4C;IAC5C,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI;MACE,oBAAoB;IACtB;IACA;MACE,eAAe;IACjB;;AAEJ;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;;EAEA","sourcesContent":[":root {\r\n    --sidebar-width: 256px;/* Define the width of your sidebar */\r\n    --sidebar-height:100% ;\r\n  }\r\n.calender-page-container{\r\n    display:flex;\r\n    flex-direction: column;\r\n    width:20%;\r\n    height:100%;\r\n    background-color: white;  \r\n    font-family: \"PlusJakartaSans\";\r\n    border-radius: 1rem;\r\n    /* margin-left: calc(85vw - var(--sidebar-width)); */\r\n    right:0%;\r\n    position:absolute;\r\n    z-index:100;\r\n    box-shadow: 1px 2px 9px rgb(219, 219, 219);\r\n    /* margin-top:-3%; */\r\n    top:0%;\r\n}\r\n.calender-page-header{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    width:100%;\r\n    font-weight: 600;\r\n    margin-bottom:2rem;\r\n    background-color: rgb(13, 13, 48);\r\n    color:white;\r\n    padding:1.5rem;\r\n}\r\nlabel{\r\n    margin-bottom: 0.75rem;\r\n    font-weight:500;\r\n    color:rgb(69, 79, 91);\r\n}\r\n.calender-page-margin-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    align-items:center;\r\n    height:100%;\r\n    padding: 1.5rem;;\r\n}\r\n.calender-page-content{\r\n    display: flex;\r\n    flex-direction:column;\r\n    width:100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius:1rem;\r\n    border:1px solid rgb(223, 227, 232);\r\n    padding-top:0.75rem;\r\n    padding-bottom:4.5rem;\r\n}\r\n.calender-in-title-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    width:100%;\r\n    padding:0.5rem;\r\n    border-bottom:1px solid rgb(231, 234, 237);\r\n}\r\n.calender-text-cotainer{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.calender-in-input{\r\n    border: none;\r\n    font-size: 22px;\r\n    color:black;\r\n}\r\n.react-calendar {\r\n    border: none; /* Remove the border from the calendar container */\r\n    width:100%;\r\n    font-family:system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\r\n  }\r\n  .react-calendar__navigation__label{\r\n    /* font-weight:600; */\r\n    font-size:1rem;\r\n  }\r\n .react-calendar__month-view__weekdays__weekday{\r\n    font-weight:400;\r\n    text-decoration:none;\r\n }\r\n.react-calendar__month-view__weekdays__weekday abbr{\r\n    text-decoration:none;\r\n}\r\n  .react-calendar__tile {\r\n    border: none; /* Remove the border from individual tiles */\r\n  }\r\n  .react-calendar__month-view__days__day--weekend{\r\n    color:black;\r\n  }\r\n  .react-calendar__tile:hover{\r\n    background-color:white;\r\n    border:1px solid transparent;\r\n  }\r\n  .react-calendar__tile--active:enabled{\r\n    background-color:rgb(64, 64, 242);\r\n    border:1px solid rgb(64, 64, 242);\r\n    color:white;\r\n  }\r\n  .react-calendar__month-view .react-calendar__tile--active:enabled:hover, .react-calendar__tile--active:enabled:focus {\r\n    background-color:rgb(64, 64, 242);\r\n    border-radius: 50%;\r\n  }\r\n  \r\n.react-calendar button {\r\n    background-color:white;\r\n    border:1px solid transparent;\r\n    color:black;\r\n  }\r\n.react-calendar__month-view .react-calendar button:hover {\r\n    cursor: pointer;\r\n    background-color:white;\r\n    border:1px solid rgb(64, 64, 242);\r\n    border-radius: 50%;\r\n\r\n  }\r\n  .react-calendar__tile:hover{\r\n    background-color:white;\r\n    border:1px solid rgb(64, 64, 242);\r\n  }\r\n.calender-page-footer{\r\n    display: flex;\r\n    align-items:center;\r\n    justify-content: flex-end;\r\n    width:100%;\r\n    padding:0.5rem;\r\n    padding-left:1.5rem;\r\n    padding-right:1.5rem; \r\n    font-family: \"PlusJakartaSans\";\r\n    box-shadow: 1px 2px 9px rgb(219, 219, 219);\r\n}\r\n.footer-btn-container{\r\n   display:flex;\r\n   width: fit-content;\r\n   height: fit-content;\r\n   background-color: white;\r\n   border-radius:0.25rem;\r\n   gap:1rem; \r\n}\r\n.calender-page-cancel-btn,.calender-page-save-btn{\r\n    display: flex;\r\n    align-items:center;\r\n    justify-content: center;\r\n    text-align:center;\r\n    padding:0.5rem;\r\n    height:2.5rem; \r\n    border-radius:0.25rem; \r\n}\r\n.calender-page-cancel-btn{\r\n    border:2px solid rgb(64, 64, 242);;\r\n    color:rgb(64, 64, 242);\r\n    background-color: white; \r\n}\r\n.calender-page-save-btn{\r\n    background-color: rgb(64, 64, 242);\r\n    border:2px solid rgb(64, 64, 242);\r\n    color:white;\r\n}\r\n.calender-div{\r\n display:flex;\r\n position:absolute;\r\n margin-top:30%;\r\n align-items:center;\r\n justify-content: center;\r\n width:100%;\r\n}\r\n.rdrCalendarWrapper{\r\n    width:95%;\r\n}\r\n.rdrDateDisplayItemActive{\r\n    border: 1px solid rgb(64, 64, 242) !important;\r\n}\r\n.rdrMonths,.rdrMonth{\r\n    width:100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.rdrInRange{\r\n background-color:rgb(217, 217, 252) !important;\r\n}\r\n.rdrStartEdge,.rdrEndEdge{\r\n    background-color:rgb(64, 64, 242) !important;\r\n    color:white !important;\r\n    /* width:80%; */\r\n    /*height:100%; */\r\n    /* border-radius: 50% !important; */\r\n    /* align-items: center !important;\r\n    justify-content: center !important; */\r\n}\r\n.rdrDayStartPreview,.rdrDayEndPreview{\r\n    background-color:rgb(64, 64, 242) !important;\r\n    color:white !important;\r\n}\r\n.rdrDayHovered > span,.rdrDayHovered > span > span,.rdrDay > span,.rdrDayInPreview{\r\n    color:white !important;\r\n}\r\n.rdrDayNumber{\r\n    z-index:10;\r\n    color:white;\r\n}\r\n@media only screen and (max-width: 1281px) and (min-width: 720px) {\r\n    .calender-page-container{\r\n      /* margin-top:-5%; */\r\n    }\r\n    .calender-in-input{\r\n      font-size: 16px;\r\n    }\r\n    \r\n}\r\n@media only screen and (max-height: 700px) and (min-height: 300px) {\r\n  .calender-page-container{\r\n    /* margin-top:-4%; */\r\n  }\r\n  .react-calendar{\r\n    /* height:100px; */\r\n  }\r\n  .calender-in-input{\r\n    font-size: 14px;\r\n  }\r\n  .calender-page-header{\r\n    margin-bottom:0;\r\n  }\r\n  .calender-page-content{\r\n    padding-bottom:1rem;\r\n  }\r\n  .react-calendar__navigation {\r\n    margin-bottom:0;\r\n  }\r\n  .calender-page-margin-container{\r\n    padding:0.75rem;\r\n  }\r\n  .calender-container{\r\n    padding:0.5rem;\r\n  }\r\n  \r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
